<template>
  
  <div class="downloads">

    <h4 class="mt-0 uc title is-4">Downloads</h4>

    <p class="mb-5">In questa sezione puoi gestire la lista dei documenti che possono essere scarciati dai clienti nell'area download.</p>

    <template v-if="loading">
      <b-skeleton :animated="true" width="20%"></b-skeleton>
      <b-skeleton :animated="true" width="40%"></b-skeleton>
      <b-skeleton :animated="true" width="60%"></b-skeleton>
      <b-skeleton :animated="true" width="80%"></b-skeleton>
    </template>

    <p class="empty" v-if="!loading && downloads.length == 0">Nessun download trovato...</p>

    <template v-if="downloads.length > 0">

      <Download v-for="(download, index) in downloads" :key="index" :download="download"/>

    </template>

    <b-button type="primary" class="mt-4" @click="addDownload()">Aggiungi download</b-button>

  </div>

</template>

<script>
import Download from './download'

export default {

  components: {Download},

  data(){

    return{
      downloads: [],
      loading: true
    }

  },

  methods: {

    addDownload(){

      /**
       * Creazione di un componente vuoto
       */
      this.downloads.push({
        id: null,
        nome_documento: null,
        nome_file: null,
        url_media: null,
        created_at: null,
        update_at: null,
        key: Math.random().toString(36).slice(2)
      });

    }

  },

  mounted(){

    var vue = this;

    axios({
      method: "get",
      url: '/data/admin/downloads/index',
    })
    .then(res => {
      
      if( res.data.downloads && res.data.downloads.length > 0 ){
        vue.downloads = res.data.downloads;
      }

    })
    .finally(() =>{
      
      this.loading = false;

    })

  }

}
</script>
